module.exports = __webpack_public_path__ + "img/Track-20.3a6a484b.png";